import { FullScreenLoading } from '@mostrans/web-components/components/base/Loading'
import React from 'react'
import { useRecoilValue } from 'recoil'
import { globalLoadingScreenAtom } from './globalStates'

function GlobalLoadingScreen() {
    const isLoading = useRecoilValue(globalLoadingScreenAtom)

    return (
        <React.Fragment>
            <FullScreenLoading show={isLoading} backdropProps={{ style: { zIndex: 100000 } }} />
        </React.Fragment>
    )
}

export default GlobalLoadingScreen